const getWalletTradeinMetadata = function (tradeIn) {
  if (tradeIn === void 0) {
    tradeIn = {};
  }
  const {
    source,
    year,
    make,
    model,
    trim,
    mileage,
    condition,
    amountOwed,
    value
  } = tradeIn;
  const metadata = {
    type: source?.toLowerCase(),
    year,
    make,
    model,
    trim,
    mileage,
    condition,
    payoff: amountOwed,
    totalValue: value
  };
  return metadata;
};
const getWalletDealMetadata = function (paymentsInfo, userModified, vehiclePrice, offerPrice) {
  if (paymentsInfo === void 0) {
    paymentsInfo = {};
  }
  if (userModified === void 0) {
    userModified = '';
  }
  if (vehiclePrice === void 0) {
    vehiclePrice = null;
  }
  if (offerPrice === void 0) {
    offerPrice = null;
  }
  const {
    loanTerm,
    downPayment,
    monthlyBudget,
    leaseMileageRange,
    dealType
  } = paymentsInfo;
  const metadata = {
    monthlyPayment: monthlyBudget,
    termLength: loanTerm,
    downPayment,
    leaseMileage: leaseMileageRange,
    type: dealType,
    // offerPrice can be 0
    offerPrice: offerPrice ?? vehiclePrice
  };
  if (userModified) {
    metadata.userModified = userModified;
  }
  return metadata;
};
const getWalletPixallMetadata = function (paymentsInfo, userModified, vehiclePrice, offerPrice) {
  if (paymentsInfo === void 0) {
    paymentsInfo = {};
  }
  if (userModified === void 0) {
    userModified = '';
  }
  if (vehiclePrice === void 0) {
    vehiclePrice = null;
  }
  if (offerPrice === void 0) {
    offerPrice = null;
  }
  return {
    tradeinMetadata: getWalletTradeinMetadata(paymentsInfo?.tradeIn),
    dealMetadata: getWalletDealMetadata(paymentsInfo, userModified, vehiclePrice, offerPrice)
  };
};
export default getWalletPixallMetadata;